import http from "../../utils/http"
/**
 * 获取发票基础信息
 */
export function apiInvoiceInfo(params) {
    return http({
        url: "/api/member/invoice",
        data: params,
        forceLogin: true
    })
}
